module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/ETIHAD GUEST SBI CARD.719823a2.png";